import edgeCommon from './common';

const postRequest = function (url, data, reload = true) {
    return  $.ajax({
                url: url,
                type: "POST",
                dataType: "JSON",
                data: data,
                beforeSend: function() {
                    $(".loading").removeClass("d-none");
                },
                success: function (response) {
                    if (response.status == "success") {
                        $(".modal").modal("hide");
                        edgeCommon.swalSuccess(response.message).then(() => {
                            if (reload) {
                                window.location.reload();
                            }
                        });
                    } else {
                        edgeCommon.swalError(response.message);
                    }
                },
                error: function(xhr) { // if error occurred
                    let err = eval("(" + xhr.responseText + ")");
                    edgeCommon.swalError(err.message);
                    console.log(`Error occurred. please try again ${err.message}`);
                },
                complete: function() {
                    $(".loading").addClass("d-none");
                },
            });
    
};


export default { postRequest };
